<template>
  <div>
    <div v-if="!getCompLoaderStatus" class="form-group">
      <div class="question">
        <!-- Question Text -->
        <h2>{{ questionTitle }}</h2>

        <!-- Question Description -->
        <p class="mt-3" v-show="question.questionDescription">
          {{ questionDesc }}
        </p>

        <!-- Question Sub Group Name -->
        <p class="personal-info mt-3" v-show="question.subGroupName">
          <span>{{ questionSubGName }}</span>
        </p>
      </div>

      <p v-if="showCoApplicant" class="personal-info mt-4 mb-4">
        {{ translatedData?.chooseAnsewer }} {{ getApplicantName }}
      </p>
      <div class="answer" v-if="answerOptions?.length">
        <ul
          :class="
            answerOptions?.length === 3
              ? 'flex-3'
              : answerOptions?.length === 4 && getAppFlow === 'Buying'
              ? 'flex-4'
              : ''
          "
        >
          <li v-for="(option, index) in answerOptions" :key="index">
            <input
              type="radio"
              :id="option.optionValue"
              :value="option.optionValue"
              v-model.trim="pickListAnswer"
            />
            <label :for="option.optionValue">
              <img
                v-if="option.optionSvgLink"
                class="dynamic-color-icons"
                :src="option.optionSvgLink"
              />
              <span>{{ option.optionName }}</span>
            </label>
          </li>
        </ul>
      </div>

      <p v-if="showCoApplicant" class="personal-info mt-4 mb-4">
        {{ translatedData?.chooseAnsewer }} {{ getCoApplicantName }}
      </p>
      <div class="answer" v-if="showCoApplicant && answerOptions.length">
        <ul :class="answerOptions?.length === 3 ? 'flex-3' : ''">
          <li v-for="(option, index) in answerOptions" :key="index">
            <input
              type="radio"
              :id="'co' + option.optionValue"
              :value="option.optionValue"
              v-model="coPickListAnswer"
            />
            <label :for="'co' + option.optionValue">
              <img
                v-if="option.optionSvgLink"
                class="dynamic-color-icons"
                :src="option.optionSvgLink"
              />
              <span>{{ option.optionName }}</span>
            </label>
          </li>
        </ul>
      </div>
    </div>

    <div class="button mt-4 justify-content-between">
      <div class="d-flex">
        <button type="button" class="btn btn-outline" @click="previousQuestion">
          <span>{{ translatedData?.previous }}</span>
        </button>
        <button
          type="button"
          class="btn"
          :class="!disableButton ? 'btn-red' : ''"
          :disabled="disableButton"
          @click="saveTheData"
        >
          <span>{{ translatedData?.continue }}</span>
        </button>
      </div>

      <div class="align-text-right col-sm-6">
        <a
          v-if="question.questionLink"
          :data-bs-toggle="
            question.questionLink && question.questionLinkDescription
              ? 'modal'
              : ''
          "
          data-bs-target="#infoModal"
          class="text-underline"
          >{{ translatedData?.questionLink }}</a
        >
      </div>
      <info-modal
        v-if="question.questionLink && question.questionLinkDescription"
        :title="translatedData?.questionLink"
        :description="translatedData?.questionLinkDescription"
        :close="translatedData?.close"
      />
    </div>
  </div>
</template>

<script>
import commonFunctions from "./../../mixins/commonfunctions";
import { translationMixin } from "../../mixins/translationMixin";
import InfoModal from "../InfoModal.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Picklist",
  mixins: [commonFunctions, translationMixin],
  components: { InfoModal },
  data() {
    return {
      pickListAnswer: "",
      coPickListAnswer: "",
      data: {
        chooseAnsewer: "Choose an answer for",
        continue: "Continue",
        previous: "Previous",
        close: "Close",
        questionLink: this.question.questionLink,
        questionLinkDescription: this.question.questionLinkDescription,
      },
    };
  },
  props: {
    question: {
      required: true,
      type: Object,
    },
    currentaq: {
      required: true,
      type: Number,
    },
    previousaq: {
      required: true,
      type: Number,
    },
  },
  created() {
    this.unAuthorizedAccess(this.question);
  },
  computed: {
    ...mapGetters(["getCompLoaderStatus"]),
    disableButton() {
      if (this.showCoApplicant) {
        if (
          this.pickListAnswer === "" ||
          this.pickListAnswer === null ||
          this.coPickListAnswer === "" ||
          this.coPickListAnswer === null
        )
          return true;
      } else {
        if (this.pickListAnswer === "" || this.pickListAnswer === null)
          return true;
      }

      return false;
    },

    showCoApplicant() {
      let que = this.question;

      if (que.questionCoFieldMapping && que.coDependentQuestionId) {
        let checkIt = this.getQuestions.some(
          (v) =>
            v.questionId === que.coDependentQuestionId &&
            v.questionAnswer === que.coDependentQuestionAnswer
        );
        if (checkIt) return true;
        if (!checkIt) return false;
      }

      return false;
    },

    hideOption() {
      let theQue = this.getQuestions.find(
        (v) =>
          v.questionFieldMapping === "client_scenario__c" ||
          v.questionFieldMapping === "candidoem__client_scenario__c"
      );

      if (theQue) {
        if (theQue.questionAnswer !== "Repeat Purchase Client") return true;
        else return false;
      }

      return true;
    },
  },
  async mounted() {
    this.checkTheDependancy(this.question);

    this.pickListAnswer =
      this.question.questionAnswer || this.question.defaultQuestionAnswer;
    this.coPickListAnswer =
      this.question.coQuestionAnswer || this.question.defaultQuestionAnswer;

    this.removeOption();
  },
  methods: {
    ...mapActions(["fetchIsNavigating"]),
    removeOption() {
      if (this.hideOption) {
        if (this.answerOptions?.find((x) => x.optionName === "Second Home")) {
          this.answerOptions = this.answerOptions?.filter(
            (y) => y.optionName !== "Second Home"
          );
        }
      }
    },

    async saveTheData() {
      this.fetchIsNavigating(true);
      if (
        this.getAppFlow === "Refinance" &&
        !this.getSubjectPropertyStatus &&
        (this.question.questionFieldMapping ===
          "do_you_own_any_additional_real_estate__c" ||
          this.question.questionFieldMapping ===
            "candidoem__do_you_own_any_additional_real_estate__c") &&
        this.pickListAnswer === "No"
      ) {
        this.info(
          "Please select YES and add or indicate property you wish to refinance."
        );
        return;
      }

      this.fetchCompLoaderStatus(true);

      let payLoad = {};

      payLoad = {
        question_id: this.question.questionId,
        answer: this.pickListAnswer,
        co_answer: this.coPickListAnswer || null,
      };

      this.addAnswerLocally(payLoad);

      if (this.getUserId && this.question.apiName === "LockLearProspectAuth") {
        let theQuestion = this.question;
        theQuestion.questionAnswer = this.pickListAnswer;
        theQuestion.coQuestionAnswer = this.coPickListAnswer;

        // payLoad for API
        payLoad = {
          prospectId: this.getUserId,
          questionsToUpdate: [theQuestion],
          orgId: this.getOrgId,
        };

        await this.$http
          .post("/question/prospect/Questions/", payLoad)
          .then((response) => {
            let resp = response.data;

            if (resp.response === "Success") {
              this.updateQueObjectWithAnswer(resp.appQuestions);
              this.updateDependantAnswers();
              this.nextQuestion();
            }

            if (resp.response === "Error") this.err(resp.message);
          })
          .catch((error) => {
            this.err(error);
            console.log(error);
          });
      }

      if (!this.getUserId || this.question.apiName === null) {
        this.updateDependantAnswers();
        this.nextQuestion();
      }

      this.fetchCompLoaderStatus(false);
    },

    nextQuestion() {
      if (
        this.getActiveQuestion + 1 > this.getQuestions.length &&
        !this.getEditModeFlag
      )
        this.$router.push("/submit-application");

      if (this.getActiveQuestion <= this.getQuestions.length)
        this.fetchActiveQuestion(this.getActiveQuestion + 1);
    },

    updateDependantAnswers() {
      let que = this.question;

      let check = this.getQuestions.some(
        (h) =>
          h.dependentQuestionId === que.questionId ||
          h.coDependentQuestionId === que.questionId
      );

      if (check) {
        this.getQuestions.forEach((k) => {
          if (
            k.dependentQuestionId === que.questionId &&
            this.pickListAnswer === "No"
          ) {
            k.questionAnswer = null;
          }

          if (
            k.coDependentQuestionId === que.questionId &&
            this.pickListAnswer === "No"
          ) {
            k.coQuestionAnswer = null;
          }
        });

        let dependantQues = this.getQuestions.filter(
          (v) => v.dependentQuestionId === que.questionId
        );

        dependantQues.forEach((t) => {
          this.getQuestions.forEach((x) => {
            if (
              x.dependentQuestionId === t.questionId &&
              t.questionAnswer === null
            ) {
              x.questionAnswer = null;
            }

            if (
              x.coDependentQuestionId === t.questionId &&
              t.coQuestionAnswer === null
            ) {
              x.coQuestionAnswer = null;
            }
          });
        });
      }
    },

    basicDecrement() {
      this.fetchActiveQuestion(this.getActiveQuestion - 1);
    },
  },
};
</script>
